//packages
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { fetchCandidatesAPI } from 'app/services/candidateAPI'
import { sendInviteAPI } from 'app/services/inviteAPI'
import { fetchCandidateAPI } from 'app/services/candidateAPI'

export const fetchCandidates = createAsyncThunk(
  'candidates/fetchCandidates',
  async (data, { rejectWithValue }) => {
    try {
      const { signal, ...searchParams } = data
      const response = await fetchCandidatesAPI(searchParams, signal)
      return response.data
    } catch (error) {
      // Add `error` here
      if (error.name === 'AbortError') {
        throw error // Let the AbortError propagate
      }
      return rejectWithValue(error.response?.data)
    }
  }
)

export const sendInvite = createAsyncThunk(
  'candidates/sentInvite',
  async (data) => {
    const response = await sendInviteAPI(data)
    return response.data
  }
)

const initialState = {
  candidates: [],
  loading: 'idle', // 'idle' : 'pending' : 'succeeded' : 'failed
  sendInviteLoading: 'idle',
  count: 0,
}

const candidateSlice = createSlice({
  name: 'employer/candidate',
  initialState,
  reducers: {
    resetAllStatus: (state, action) => {
      state.loading = 'idle'
      state.sendInviteLoading = 'idle'
    },
    setCandidates: (state, action) => {
      state.candidates = action.payload.candidates
      state.count = action.payload.count || state.count
      state.loading = 'succeeded'
    },
  },
  extraReducers: (builder) => {
    //get candidates
    builder.addCase(fetchCandidates.pending, (state, action) => {
      state.loading = 'pending'
      state.candidates = []
    })

    builder.addCase(fetchCandidates.rejected, (state, action) => {
      state.loading = 'failed'
      state.candidates = []
    })

    builder.addCase(fetchCandidates.fulfilled, (state, action) => {
      state.candidates = action.payload.candidates
      state.count = action.payload.count
      state.loading = 'succeeded'
    })

    //sentInvite
    builder.addCase(sendInvite.pending, (state, action) => {
      state.sendInviteLoading = 'pending'
    })
    builder.addCase(sendInvite.fulfilled, (state, action) => {
      state.sendInviteLoading = 'succeeded'
    })
    builder.addCase(sendInvite.rejected, (state, action) => {
      state.sendInviteLoading = 'failed'
    })

    //Clear data after user logout
    builder.addCase('auth/LogOut', (state) => {
      state.candidates = []
    })
  },
})

export const getCandidates = (state) => state.candidate.candidates
export const getCandidatesCount = (state) => state.candidate.count
export const getCandidatesLoading = (state) => state.candidate.loading

export const { resetAllStatus, setCandidates } = candidateSlice.actions

export default candidateSlice.reducer

export const getCandidateById = createAsyncThunk(
  'candidates/getCandidateById',
  async (data) => {
    const response = await fetchCandidateAPI(data)
    return response.data
  }
)